"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var braftUniqueIndex = 0;

var UniqueIndex = exports.UniqueIndex = function UniqueIndex() {
  return braftUniqueIndex += 1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/braft-utils/dist/base.js
// module id = 1799
// module chunks = 0